const regCompanyPath =
  /^\/company\/\d+(?:\/(?:gongsi|jingxian|jingzhuang|past|shangshi|sifa|zhishi|zizhu))?\/?$/;
const regHumanPath =
  /^\/human\/\d+-c\d+(?:\/(?:lishi|kongzhi|group|risk|past|partner|tupu|news))?\/?$/;
const regOrganizePath = /^\/organize\/[\da-zA-Z]+\/?$/;
const regBrandPath = /^\/brand\/[\da-zA-Z]+\/?$/;
const regProduct = /^\/product\/[\da-zA-Z]+\/?$/;

const getPageName = () => {
  const path = window.location.pathname;

  switch (true) {
    case path === '/' || path === '/home':
      return 'home';

    case path === '/vipintro':
      return 'vipintro';

    case path === '/vipbusiness':
      return 'vipbusiness';

    case path === '/search':
      return 'search';

    case regCompanyPath.test(path):
      return 'company';

    case regHumanPath.test(path):
      return 'human';

    case regOrganizePath.test(path):
      return 'organize';

    case regBrandPath.test(path):
      return 'brand';

    case regProduct.test(path):
      return 'product';

    default:
      return '';
  }
};

export default getPageName;
